import React from 'react';
import T from '../misc/t';

require('stylesheets/boilerplate/footer');


const Footer = React.createClass({
  render() {
    return (
      <div className="footer">
        <a href="http://www.developmentgateway.org/" target="_blank"><img alt={{k: 'site.logo'}} className="footer-logo" src="images/dg-logo.svg"/></a>
      </div>
    );
  },
});

export default Footer;



/** WEBPACK FOOTER **
 ** ./app/scripts/components/boilerplate/footer.jsx
 **/